/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IRepoUploadCompleteMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  uploadId: Types.Scalars['String']['input'];
  parts: Array<Types.ISecureUploadPartParams> | Types.ISecureUploadPartParams;
  size: Types.Scalars['BigInt']['input'];
  contentType: Types.AssetContentTypeEnum;
  repoName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  assetId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type IRepoUploadCompleteMutation = {
  __typename?: 'Mutation';
  repoUploadComplete?: {
    __typename?: 'RepoUploadCompletePayload';
    success: boolean;
    errors?: Array<string> | null;
    asset?: { __typename?: 'Asset'; id: string; depositStatus: Types.DepositStatusEnum } | null;
  } | null;
};

export const RepoUploadCompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'repoUploadComplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'SecureUploadPartParams' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInt' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetContentTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repoUploadComplete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uploadId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'parts' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'parts' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contentType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'repoName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IRepoUploadCompleteMutation, IRepoUploadCompleteMutationVariables>;
